module.exports = function() {
  return new Worker(__webpack_public_path__ + "ef5361e5acb578095f37.worker.js");
};